import { lazy, type ComponentType } from 'react';
import type { ViewRegistry } from '@/app/routing/view-registry';
import { useNavigation } from '@/app/navigation/use-navigation';

const Usuario = lazy(() => import('@/features/permissions/components/permission/Usuario'));
const Perfil = lazy(() => import('@/features/permissions/components/permission/Perfil'));
const LogPermissao = lazy(() => import('@/features/auditoria/components/LogPermissao'));

function makeOnBackOnly(Component: ComponentType<{ onBack: () => void }>) {
  return function View() {
    const { actions } = useNavigation();
    return <Component onBack={actions.goBack} />;
  };
}

export const adminViews: Partial<ViewRegistry> = {
  equipe: { component: makeOnBackOnly(Usuario), guard: { screen: 'equipe' } },
  perfis: { component: makeOnBackOnly(Perfil), guard: { screen: 'perfis' } },
  'auditoria-logs': {
    component: makeOnBackOnly(LogPermissao),
    guard: { screen: 'auditoria-logs' },
  },
};
